



























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as service from '@/services/business-units';
import BusinessUnitModel from '@/models/business-unit-model';
import IBusinessUnit from '@/interfaces/business-units';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { toUpperCase } from '@/helpers/toUpperCase';
import BusinessUnitForm from '@/components/business-units/business-unit-form.vue';
import { filterByText } from '@/helpers/filterByText';
import {
  MESSAGE_BUSINESS_UNIT_UPDATE_ERROR,
  MESSAGE_BUSINESS_UNIT_LOAD_ERROR,
} from '@/settings/consts/messages';
import { errorHandling } from '@/helpers/errorHandling';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import {
  ERROR_CODE_CNPJ_INVALID,
  ERROR_CODE_CNPJ_NOT_FOUND,
} from '@/settings/consts/api-error';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    BusinessUnitForm,
  },
})
export default class BusinessUnits extends BaseComponent {
  public formIsEdit: boolean = false;
  public formIsView: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filter: any = {
    term: '',
    status: true,
  };

  public statusList: any[] = [
    {
      value: null,
      label: 'Todas',
    },
    {
      value: true,
      label: 'Ativa',
    },
    {
      value: false,
      label: 'Inativa',
    },
  ];

  public headers: any = [
    { text: 'CNPJ', value: 'cnpj' },
    { text: 'Razão Social', value: 'razaoSocial' },
    { text: 'Cidade', value: 'cidade' },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },    
  ];
  public data: BusinessUnitModel[] = [];
  public item: BusinessUnitModel = new BusinessUnitModel();

  public clients: any[] = [];

  public onFilter(): void {
    this.load();
  }

  public beforeMount(): void {
    this.load();
  }

  public disableUpdateStatus(item: BusinessUnitModel): boolean {
    return !item.ativo;
  }

  public onEditItem(item: BusinessUnitModel, isView: boolean = false): void {
    this.loader.start('Carregando item...');

    const onError = (error) => {
      this.loader.stop();

      const errorMessages = {
        default: MESSAGE_BUSINESS_UNIT_LOAD_ERROR,
        [ERROR_CODE_CNPJ_NOT_FOUND]: !!error.data
          ? error.data.message
          : MESSAGE_BUSINESS_UNIT_LOAD_ERROR,
        [ERROR_CODE_CNPJ_INVALID]: !!error.data
          ? error.data.message
          : MESSAGE_BUSINESS_UNIT_LOAD_ERROR,
      };

      const message = errorHandling(error, errorMessages);

      this.toast.show(message, 'error');
    };
    service.getBusinessUnit(item.id).subscribe((data) => {
      this.item = new BusinessUnitModel(data);
      this.formOpen = true;
      this.formIsEdit = true;
      this.formIsView = isView;
      this.loader.stop();
    }, onError);
  }

  public onDeleteItem(item: BusinessUnitModel): void {
    const deleteItem = () => {
      this.loader.start('Deletando registro...');
      service.deleteBusinessUnit(item.id).subscribe(
        (data) => {
          this.loader.stop();
          this.load();
        },
        (err) => {
          this.loader.stop();
          this.toast.show('Ocorreu um erro ao excluir o registro', 'error');
        },
      );
    };

    this.dialog.show(
      'error',
      'Excluir Médico',
      'Tem certeza que deseja excluir este médico?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = search.toString().toLowerCase();
    const searchCNPJ = search.toString().replaceAll(/[^0-9a-zA-Z]/g, '');
    return items.filter((row) => {
      const cnpj = row.cnpj.replaceAll(/[^0-9a-zA-Z]/g, '');
      return (
        filterByText({ cnpj }, ['cnpj'], searchCNPJ) ||
        filterByText(row, ['cnpj', 'razaoSocial', 'cidade'], searchLower)
      );
    });
  }

  public saveItem(): void {
    this.closeForm();
    this.load();
  }

  public toggleItemStatus(item: BusinessUnitModel, status: boolean): void {
    this.loader.start('Atualizando registro...');
    const payload = item.toJson();
    payload.ativo = status;
    const onError = (error) => {
      this.loader.stop();

      const errorMessages = {
        default: MESSAGE_BUSINESS_UNIT_UPDATE_ERROR,
        [ERROR_CODE_CNPJ_NOT_FOUND]: !!error.data
          ? error.data.message
          : MESSAGE_BUSINESS_UNIT_LOAD_ERROR,
        [ERROR_CODE_CNPJ_INVALID]: !!error.data
          ? error.data.message
          : MESSAGE_BUSINESS_UNIT_UPDATE_ERROR,
      };

      const message = errorHandling(error, errorMessages);

      this.toast.show(message, 'error');
    };
    service.updateBusinessUnit(payload).subscribe((data) => {
      item.ativo = status;
      this.loader.stop();
    }, onError);
  }

  public closeForm(): void {
    this.item = new BusinessUnitModel();
    this.formOpen = false;
    resetModalScroll();
  }

  private load(): void {
    this.data = [];
    this.loading = true;

    service.getBusinessUnitsStatus(this.filter.status).subscribe(
      (x) => {
        this.data = x.map((item) => {
          return new BusinessUnitModel(item);
        });
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }
}
